import React from 'react'
import "./aboutXLarge.css"
import "./about.css"
import "./aboutMedium.css"
import "./aboutSmall.css"
import "./aboutXSmall.css"
import { Blob1 } from '../../components';
import { Blob2 } from '../../components';
import { Blob3 } from '../../components';
import cactushead from '../../assets/cactushead.png';
import petithead from '../../assets/petithead.png';
import luca from '../../assets/lucahalf.png';
import luca2 from '../../assets/lucaback.png';
import lucaHochedezResume from './lucahochedezcv.pdf';
 
const About = () => {
  
  return (
    <section className='about-wrapper' id='about'>
        <div className='title-wrapper'>
            <h1>LUCA</h1>
            <div className='title-line'>
                <p>Who am I ?</p>
            </div>
        </div>

        <div className='about-content'>
            <div className='about-intro'> 
                <p>
                    I am <span style={{color:'#eee8aa'}}>Luca</span>, a <span>frontend developer </span> passionate about crafting creative digital experiences.<br/>
                    <br/>
                    In my diverse and impactful journey, I've delved deep into frontend development, translating design concepts into code and ensuring fluid user interactions.<br/>
                    <br/>
                    Hands-on experience with numerous projects made me face plenty of challenges,providing opportunity to gain knowledge in Javascript, master my skills with frameworks, improve my creative thinking, and innovate in my coding process.
                </p>
                <div className='resume-wrapper'>
                    <p>Download</p>
                    <a className='resume-btn' href={lucaHochedezResume} target='_blank' rel="noreferrer" > 
                        My resume
                    </a>
                </div>
                
            </div> 
            <div className='about-photo'>
                <div className='block-blobs'>
                    <div className='block-blob1'>
                         <Blob1 className='blob1' />
                    </div>
                    <div className='block-blob2'>
                         <Blob2 className='blob2' />
                    </div>
                    <div className='block-blob3'>
                         <Blob3 className='blob3' />
                    </div>
                    <div className='floating-photo-wrapper'>
                        <div className='photo'>
                            <img src={luca} loading='lazy' alt='Me' title='Yep, this is me' />
                        </div>
                        <div className='photoCactus'>
                            <img src={cactushead} loading='lazy' alt='Cactus' title="My cat Cactus, the mother" />
                        </div>
                        <div className='photoPetit'>
                            <img src={petithead} loading='lazy' alt='Petit' title="My cat Petit, the son" />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div className='about-transition'>
            <p>Beyond the code, I'm a tech enthusiast constantly exploring our evolving industry, cultivating an insatiable curiosity for the world and networking with my peers.<br/>
            Outside the digital realm, I am a marathon runner, a film maker, and always up for a new adventure. </p>
        </div>

        <div className='about-content'>
            <div className='about-photo'>
                <div className='block-blobs'>
                    <div className='block-blob1'>
                         <Blob1 className='blob1' />
                    </div>
                    <div className='block-blob2'>
                         <Blob2 className='blob2' />
                    </div>
                    <div className='second-block-blob3'>
                         <Blob3 className='blob3' />
                    </div>
                    <div className='photo2'>
                        <img src={luca2} loading='lazy' alt='Me again' />
                    </div>
                    
                </div>
            </div>

            <div className='about-intro'>
                <p>
                Before my coding career, I've navigated the vibrant hospitality scene for over a decade, from bustling bars to lively restaurants.<br/>
                <br/>
                These experiences have refined my interpersonal skills, resilience, adaptability, and attention to detail. Multitasking under pressure and delivering precise and on-demand service have become second nature.
                <br/>
                <br/>
                With 3 years of programming and 10 years in hospitality, I bring a unique organization, communication, and problem-solving skills in all my collaborations.
                </p>
            </div>
        </div>

        <div className='about-conclusion'>
            <p>
            Let's embark on this exciting journey together and bring your ideas to life.<br/>
            Reach out, and let's create something amazing.
            </p>
        </div>

        <div className='shape'><div className='circle'></div></div>
    </section>
  )
}

export default About